module.exports = __webpack_public_path__ + "img/google-adwords.3efe0771.svg";